export const EventListRoad = {
  // PSC report dispatch states (AMB_RPT_ST_*). `incoming` also covers a report
  // that has no ambulance_report row yet — received, not dispatched.
  incoming: {
    label: 'incoming',
    bg: 'danger',
  },
  arrived: {
    label: 'arrived',
    bg: 'bluePrimary',
  },
  high: {
    label: 'high',
    bg: 'danger',
  },
  congestionLevel: {
    label: 'congestion level',
    bg: 'danger',
  },
  medium: {
    label: 'medium',
    bg: 'warning',
  },
  low: {
    label: 'low',
    bg: 'greenPrimary',
  },
};

export type EventListRoadType = keyof typeof EventListRoad;
